// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2UhRH","item":"PaymentsMobile_item__155x5","label":"PaymentsMobile_label__3Dev3","amount":"PaymentsMobile_amount__2lYmQ"};